import { Controller } from "@hotwired/stimulus"

// Ustawia numer odbiorcy SMS w polu tekstowym po kliknięciu w „chip" z numerem
// (telefon / komórka kontaktu). Pole pozostaje edytowalne.
export default class extends Controller {
  static targets = ["number"]

  pick(event) {
    this.numberTarget.value = event.params.number
  }
}
